import script from "./Dropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropzone.vue?vue&type=script&setup=true&lang=js"

import "./Dropzone.vue?vue&type=style&index=0&id=7851ea3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7851ea3a"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
